import { Component, effect, inject } from '@angular/core';
import { AddClassToTabPanelsDirective } from '../../../directives/add-class-to-tab-panels.directive';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { DataLayerFormComponent } from '../../organisms/data-layer-form/data-layer-form.component';
import { DataLayerTypeEntryComponent } from '../data-layer-type-entry/data-layer-type-entry.component';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../../organisms/mask/mask.component';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SearchInputComponent } from '../../atoms/search-input/search-input.component';
import { SharedModule } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { TabViewModule } from 'primeng/tabview';
import { getState } from '@ngrx/signals';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { DataLayerType } from '../../../models/data-layer-type';
import { StateFilter } from '../../../stores/crud.state';

@Component({
  selector: 'app-year-pick-list',
  standalone: true,
  imports: [
    AddClassToTabPanelsDirective,
    CdkDrag,
    CdkDropList,
    DataLayerFormComponent,
    DataLayerTypeEntryComponent,
    HeaderComponent,
    MaskComponent,
    NgForOf,
    NgIf,
    RouterOutlet,
    ScrollPanelModule,
    SearchInputComponent,
    SharedModule,
    SidebarModule,
    TabViewModule,
    NgClass,
  ],
  templateUrl: './year-pick-list.component.html',
  styleUrl: './year-pick-list.component.scss',
})
export class YearPickListComponent {
  readonly store = inject(DataLayerTypeStore);
  readonly dataLayerStore = inject(DataLayerStore);

  groupedDataLayerTypes?: { [type: string]: DataLayerType[] };

  filterQuery: StateFilter = {
    query: '',
    category: [],
    locked: null,
    published: null,
    tags: [],
    products: [],
    ids: undefined,
  };

  constructor() {
    effect(() => {
      const dataLayerTypeState = getState(this.store);

      if (dataLayerTypeState.initialized) {
        this.groupedDataLayerTypes = this.store.groupedByType();
      }
    });
  }

  /**
   * Filters the available types based on the provided search term.
   *
   * @param {string} searchTerm - The term to filter the types by.
   * @return {void} This method does not return a value.
   */
  filterTypes(searchTerm: string): void {
    this.filterQuery.query = searchTerm;
    this.updateFilter();
  }

  /**
   * Updates the filter for the store after a delay of 10 milliseconds.
   * The method applies the current filter query to the store.
   *
   * @return {void} This method does not return any value.
   */
  updateFilter(): void {
    setTimeout(() => {
      this.store.updateFilter(this.filterQuery);
    }, 10);
  }
}
